import { lazy } from 'react'

import { withModal } from '@wwt/ui/components/HOC/withModal.tsx'
import { withSuspense } from '@wwt/ui/components/HOC/withSuspence.tsx'
import { withUnsavedChangesModal } from '@wwt/ui/components/HOC/withUnsavedChangesModal.tsx'

import { ModalTypes, ReactModalInfo } from '../types/modalTypes.ts'
import { BaseModalSkeleton } from '../ui/BaseModalSkeleton.tsx'

export const modalsMap: Record<ModalTypes, ReactModalInfo> = {
	[ModalTypes.OfferConfiguration]: {
		component: withUnsavedChangesModal(
			lazy(() => import('@wwt/widgets/modal/offer-configuration')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.ChatAssistant]: {
		component: withModal(
			lazy(() => import('@/widgets/ChatModal')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.BigFilter]: {
		component: withUnsavedChangesModal(
			lazy(() => import('@/widgets/BigFilter')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.RequestPersonalDiscount]: {
		component: withModal(
			lazy(() => import('@wwt/widgets/modal/request-personal-discount')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.Nps]: {
		component: withModal(
			lazy(() => import('@wwt/widgets/modal/nps')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.TutorialVideo]: {
		component: withModal(
			lazy(() => import('@wwt/widgets/modal/tutorial-video')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.TutorialReview]: {
		component: withModal(
			lazy(() => import('@wwt/widgets/modal/tutorial-review')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.TutorialMobile]: {
		component: withModal(
			lazy(() => import('@wwt/widgets/modal/tutorial-mobile')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.ReasonReview]: {
		component: withModal(
			lazy(() => import('@wwt/widgets/modal/reason-review')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.ReasonInfo]: {
		component: withModal(
			lazy(() => import('@wwt/widgets/modal/reason-info')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.CreateSet]: {
		component: withModal(
			lazy(() => import('@wwt/widgets/modal/create-set')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.RenameSet]: {
		component: withUnsavedChangesModal(
			lazy(() => import('@wwt/widgets/modal/rename-set')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.DeleteSet]: {
		component: withModal(
			lazy(() => import('@wwt/widgets/modal/delete-set')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.Reservations]: {
		component: withModal(
			lazy(() => import('@/widgets/ReservationsModal')),
			BaseModalSkeleton
		)
	},
	[ModalTypes.Registration]: {
		dialog: withSuspense(
			lazy(() =>
				import('@/features/auth').then(m => ({ default: m.RegistrationForm }))
			),
			null
		)
	},
	[ModalTypes.Login]: {
		dialog: withSuspense(
			lazy(() =>
				import('@/features/auth').then(m => ({ default: m.LoginForm }))
			),
			null
		)
	},
	[ModalTypes.MoreParameters]: {
		component: withUnsavedChangesModal(
			lazy(() =>
				import('@wwt/pages/comparison').then(m => ({
					default: m.MoreParameters
				}))
			),
			BaseModalSkeleton
		)
	}
}
